import { t } from 'ttag';
import { getLocale } from 'utils.js';
import countriesEn from './world.en.json';
import countriesFi from './world.fi.json';
import countriesSe from './world.se.json';

export const WEEKDAYS = () => [
    // TRANS: Full names of weekdays
    t`MONDAY`,
    t`TUESDAY`,
    t`WEDNESDAY`,
    t`THURSDAY`,
    t`FRIDAY`,
    t`SATURDAY`,
    t`SUNDAY`,
];

export const WEEKDAYS_SHORT = () => [
    // TRANS: Short variations of weekday names. Preferably ~3 letters
    t`MON`,
    t`TUE`,
    t`WED`,
    t`THU`,
    t`FRI`,
    t`SAT`,
    t`SUN`,
];

export const MONTHS = i => [
    // TRANS: Short variations of the names of months. Preferably ~3 letters
    t`JAN`,
    t`FEB`,
    t`MAR`,
    t`APR`,
    t`MAY`,
    t`JUN`,
    t`JUL`,
    t`AUG`,
    t`SEP`,
    t`OCT`,
    t`NOV`,
    t`DEC`,
][i];

const COUNTRY_MAPS = Object.freeze({
    en: Object.freeze(Object.fromEntries(countriesEn.map(c => [c.code, c.name]))),
    fi: Object.freeze(Object.fromEntries(countriesFi.map(c => [c.code, c.name]))),
    se: Object.freeze(Object.fromEntries(countriesSe.map(c => [c.code, c.name]))),
});

const COUNTRY_OPTIONS = Object.freeze({
    en: Object.freeze(countriesEn.map(({ code, name }) => ({ value: code, label: name }))),
    fi: Object.freeze(countriesFi.map(({ code, name }) => ({ value: code, label: name }))),
    se: Object.freeze(countriesSe.map(({ code, name }) => ({ value: code, label: name }))),
});

export const getCountryName = code => COUNTRY_MAPS[getLocale()]?.[code] ?? COUNTRY_MAPS.fi[code] ?? code;
export const getCountryOptions = () => COUNTRY_OPTIONS[getLocale()] ?? COUNTRY_OPTIONS.fi;
